import React, { useState, useRef, useEffect } from 'react';
// import { Button } from '../../Atoms/Button';
import capacity from '../../Assets/products_landing/capacity.svg';
import ReCaptchaV2 from 'react-google-recaptcha';
import { ToastContainer, toast } from 'react-toastify';


import bgRing from '../../Assets/home/product_carousel/circle.svg';
import type2 from '../../Assets/home/carousel_images/type2.svg';
import threePin from '../../Assets/home/carousel_images/3pin.svg';
import css2 from '../../Assets/home/carousel_images/ccs2.svg';
import six0309 from '../../Assets/home/carousel_images/six0309.svg';
import ether from '../../Assets/home/carousel_images/ether.png';
import gsm from '../../Assets/home/carousel_images/gsm.png';
import wifi from '../../Assets/home/carousel_images/wifi.png';
import one from '../../Assets/products_landing/ACCharger7Sfrontview.png';
import two from '../../Assets/products_landing/ACHybridv1.png';
import three from '../../Assets/products_landing/ACCharger15D.png';
import four from '../../Assets/products_landing/compactac75kWwithdisplay.png';
import five from '../../Assets/products_landing/BharatACfrontview.png';
import six from '../../Assets/products_landing/ACCharger22Dfrontview.png';
import vehicle1 from '../../Assets/home/carousel_images/6.png'
import vehicle2 from '../../Assets/home/carousel_images/7.png'
import vehicle3 from '../../Assets/home/carousel_images/8.png'
import vehicle4 from '../../Assets/home/carousel_images/9.png'
import home from '../../Assets/home/newIcon/1.png'
import fleet from '../../Assets/home/newIcon/4.png'
import cpo from '../../Assets/home/CPO.png'
import realestate from '../../Assets/home/newIcon/5.png'
import retail from '../../Assets/home/newIcon/3.png'
import workplace from '../../Assets/home/newIcon/2.png'
import ARAIlogo from '../../Assets/products_landing/ARAIlogo.png'

// docs
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';

import { SwitchTransition, Transition } from 'react-transition-group';
import { gsap } from 'gsap';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Button } from '../../Atoms';
import FormModal from './FormModal';

const tabData = [
  {
    title: 'Ksipra Compact AC',
    desc: '',
    availFrom: 3.3,
    availTo: ["7.5", "11", "22"],
    fileLink: "https://resources.verdemobility.com/files/CompactAC.pdf",
    imgSrc: four,
    socketType: [0, 1, 2],
    connectivity: [0, 1, 2],
    compatibility: [0, 1, 2],
    use: [0, 1, 2, 3, 4],
    variants: ['4.3" Graphic Display', 'Without Display'],
    icon: ARAIlogo
  },
  {
    title: 'Ksipra 7S Charger',
    connectivity: [0, 1, 2],
    desc: '',
    availFrom: 7,
    availTo: ["11", "22"],
    fileLink: "https://resources.verdemobility.com/files/KsipraAC7S.pdf",
    imgSrc: one,
    socketType: [0],
    compatibility: [2],
    use: [0, 1, 2, 3, 4],
    variants: [],
    icon: ''
  },
  {
    title: 'Ksipra Bharat AC',
    desc: '',
    availFrom: 10,
    availTo: false,
    fileLink: "https://resources.verdemobility.com/files/bharatac.pdf",
    imgSrc: five,
    socketType: [1, 2],
    connectivity: [0, 1, 2],
    compatibility: [0, 1, 2],
    use: [1, 2, 3, 4],
    variants: [],
    icon: ARAIlogo
  },

  {
    title: 'Ksipra Hybrid AC',
    desc: '',
    availFrom: 15,
    availTo: false,
    fileLink: "https://resources.verdemobility.com/files/hybridac.pdf",
    imgSrc: two,
    socketType: [0, 1, 2],
    connectivity: [0, 1, 2],
    compatibility: [0, 1, 2],
    use: [1, 2, 3, 4],
    variants: [],
    icon: ARAIlogo
  },
  {
    title: 'AC 15D Charger',
    desc: '',
    availFrom: 15,
    availTo: false,
    fileLink: "https://resources.verdemobility.com/files/AC15kwDualcharger.pdf",
    imgSrc: three,
    socketType: [0],
    connectivity: [0, 1, 2],
    compatibility: [2],
    use: [0, 1, 2, 3, 4],
    variants: [],
    icon: ''
  },
  {
    title: 'AC 22D Charger',
    desc: '',
    availFrom: 22,
    availTo: ["44"],
    fileLink: "https://resources.verdemobility.com/files/AC22kWDualCharger.pdf",
    imgSrc: six,
    socketType: [0],
    connectivity: [0, 1, 2],
    compatibility: [2, 3],
    use: [1, 2, 3, 4],
    variants: [],
    icon: ''
  }
];

export default function ACChargerFlex() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [hasMounted, setHasMounted] = useState(false);
  const sliderRef = useRef(null);


  useEffect(() => {
    // Delay slightly to allow layout to settle
    setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickGoTo(0);
        window.dispatchEvent(new Event("resize"));
      }
    }, 50);
  }, [activeIdx]);

  const connectivity = [
    { desc: 'GSM', icon: gsm },
    { icon: ether, desc: 'Ethernet' },
    { icon: wifi, desc: 'WiFi' },
  ];
  const socketType = [
    { desc: 'Type 2 ', icon: type2 },
    { desc: 'IEC 60309', icon: six0309 },
    { icon: threePin, desc: '3 Pin' },
    { desc: 'CCS2', icon: css2 },
  ];
  const CompatibilityType = [
    { desc: '', icon: vehicle3, title: 'Two Wheeler' },
    { desc: '', icon: vehicle2, title: 'Three Wheeler' },
    { icon: vehicle1, desc: '', title: 'Four Wheeler' },
    { desc: '', icon: vehicle4, title: 'Six Wheeler' },
  ];
  const userType = [
    { desc: 'Home', icon: home },
    { icon: fleet, desc: 'Fleet' },
    { desc: 'Real Estate', icon: realestate },
    { desc: 'Retail & Hospitality ', icon: retail },
    { desc: 'Workplace', icon: workplace },
  ];
  const variants = [
    { desc: '4.3" Graphic Display', icon: '' },
    { icon: '', desc: 'Without Display' },
    { desc: '20X4 Character LCD', icon: '' },
    { desc: '4.3" Graphic LCD', icon: '' },
  ];



  const tabs = ['Ksipra Compact AC', 'Ksipra 7S Charger', 'Ksipra Bharat AC', 'Ksipra Hybrid AC', 'AC 15D Charger', 'AC 22D Charger'];
  const Chip = ({ data, type = false, userType = false }) => {
    const { desc, icon } = data;
    return (
      <div className="flex flex-nowrap gap-2 md:gap-3 items-center ">
        {icon && <img
          loading="lazy"
          src={icon}
          alt={desc}
          className={`${type ? 'h-8' : 'h-6'} md:${type ? 'h-14' : 'h-8'} w-auto object-contain objet-center`}
          title={data?.title}
        />}
        <span className={`${userType ? ' py-2 font-medium' : 'font-semibold'} text-sm sm:text-base lg:${userType ? 'text-base' : 'text-lg'}   font-poppins   `}>
          {desc}
        </span>
      </div>
    );
  };

  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 10000,
    centerMode: true,
    afterChange: (index) => {
      const isSmallDevice = window.innerWidth;
      if (isSmallDevice < 800) {
        setActiveIdx(index);
      }
    },
    variableWidth: true,
    infinite: true,
    focusOnSelect: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 512,
        settings: {
          variableWidth: true,
          centerMode: true,
        },
      },
    ],
  };

  const sliderSettings2 = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    adaptiveHeight: true,
    infinite: true,
  };

  const exitAnim = (node) => {
    gsap.to(node, {
      duration: 0.3,
      opacity: 0,
    });
  };

  const enter = (node) => {
    gsap.fromTo(
      node,
      {
        opacity: 0,
      },
      {
        duration: 0.5,
        opacity: 1,
      }
    );
  };

  const [productTitle, setProductTitle] = useState("");


  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {

    setIsModalOpen(true)
  };



  return (
    <>
      <ToastContainer />
      <section className="flex lg:flex-row flex-col-reverse gap-3 relative gap-y-6 bg-light-gradient blade-margin-top-sm">
        <div className=" basis-32  xl:basis-20 grow shrink  col-end-7 flex items-center  lg:justify-end md:pt-20 pb-0 px-3 pl-5 lg:pl-20 xl:pl-10">
          <SwitchTransition>
            <Transition
              appear={true}
              timeout={300}
              in={true}
              key={activeIdx}
              onExit={exitAnim}
              onEnter={enter}
              mountOnEnter
              unmountOnExit
            >
              <div className="basis-72 mr-0 xl:mr-0 grow shrink  max-w-xl  flex flex-col md:gap-4 xl:gap-4 mt-4">
                <span className="flex xxl:text-[48px] xl:text-[40px] lg:text-[40px] md:text-[36px] text-[32px] xl:leading-tight lg:leading-tight md:leading-tight leading-normal font-gilroy font-semibold">
                  {tabData[activeIdx].title}
                  <img src={tabData[activeIdx].icon} className="ml-4" />
                </span>
                {/* <p className="font-poppins font-light mt-2  text-base  md:text-xl  xl:text-2xl max-w-xl lg:w-full ">
                  {tabData[activeIdx].desc}
                </p> */}
                <div className="flex flex-col divide-y divider-grey">
                  <div className="flex flex-row items-center flex-nowrap gap-4 py-2  sm:py-4">
                    <span className="font-poppins font-semibold  text-lg xl:text-xl">
                      Connectivity:
                    </span>
                    <div className="flex flex-wrap gap-2 items-center">
                      {tabData[activeIdx].connectivity.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={connectivity[elem]} />
                          </div>
                        );
                      })}
                    </div>
                    {/* <div>
                      <span className="font-poppins font-semibold  text-lg xl:text-xl">
                        Compatibility
                      </span>
                      <div className='flex space-x-2'>
                        <img
                          loading="lazy"
                          src={vehicle1}
                          alt="vehicle"
                          className=" h-6  md:h-8 w-auto object-contain objet-center"
                          title='4 Wheeler'
                        />

                        <img
                          loading="lazy"
                          src={vehicle2}
                          alt="vehicle"
                          className=" h-6  md:h-8 w-auto object-contain objet-center"
                          title='3 Wheeler'
                        />

                        <img
                          loading="lazy"
                          src={vehicle3}
                          alt="vehicle"
                          className=" h-6  md:h-8 w-auto object-contain objet-center"
                          title='2 Wheeler'
                        />

                        <img
                          loading="lazy"
                          src={vehicle4}
                          alt="vehicle"
                          className=" h-6  md:h-8 w-auto object-contain objet-center"
                          title='6 Wheeler'
                        />
                      </div>


                    </div> */}
                  </div>
                  <div className="flex flex-row items-center flex-nowrap gap-4 py-2  sm:py-3 lg:py-5">
                    <span className="font-poppins font-semibold  text-lg xl:text-xl">
                      Charging Capacity:
                    </span>
                    <div className="flex flex-wrap gap-3 items-center">
                      {tabData[activeIdx].availFrom && (
                        <Chip
                          data={{
                            desc:
                              tabData[activeIdx].availFrom +
                              ' kW' +
                              (tabData[activeIdx].availTo
                                ? ' / ' + tabData[activeIdx].availTo.map(value => value + ' kW').join(' / ')
                                : ''),
                            // (tabData[activeIdx].availTo
                            //   ? ' to ' + tabData[activeIdx].availTo + ' kW'
                            //   : ''),
                            icon: capacity,
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex flex-row items-center flex-nowrap gap-4 py-2  sm:py-3 lg:py-5">
                    <span className="font-poppins font-semibold  text-lg xl:text-xl">
                      Plugs Available:
                    </span>
                    <div className="flex flex-wrap gap-2 items-center">
                      {tabData[activeIdx].socketType.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={socketType[elem]} />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className='flex items-center gap-4 py-2  sm:py-3 lg:py-5 block lg:hidden'>
                    <span className="font-poppins font-semibold text-lg xl:text-xl">
                      Compatibility:
                    </span>
                    <div className='flex space-x-4'>
                      {tabData[activeIdx].compatibility.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={CompatibilityType[elem]} type="true"/>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className=' gap-4 py-2  sm:py-3 lg:py-5 flex'>
                    <span className="font-poppins font-semibold text-lg xl:text-xl w-1/6">
                      Use Type:
                    </span>
                    <div className='flex flex-wrap w-5/6'>
                      {tabData[activeIdx].use.map((elem, index) => {
                        return (
                          <div key={index} className="mr-4">
                            <Chip data={userType[elem]} userType="true" />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {tabData[activeIdx].variants.length > 0 && <div className='flex items-center gap-4 py-2  sm:py-3 lg:py-5 block'>
                    <span className="font-poppins font-semibold text-lg xl:text-xl">
                      Display Size:
                    </span>
                    <div className='flex flex-wrap'>
                      {tabData[activeIdx].variants && (
                        <Chip
                          data={{
                            desc:
                              (tabData[activeIdx].variants
                                ? tabData[activeIdx].variants.map(value => value).join(' / ')
                                : ''),
                            // (tabData[activeIdx].availTo
                            //   ? ' to ' + tabData[activeIdx].availTo + ' kW'
                            //   : ''),                            
                          }}
                        />
                      )}
                      {/* {tabData[activeIdx].variants.map((elem, index) => {
                        return (
                          <div key={index} className="mr-4">
                            <Chip data={variants[elem]} userType="true" />
                          </div>
                        );
                      })} */}
                    </div>
                  </div>}
                  <div className="flex items-center py-2 sm:py-3 gap-3">
                    <div onClick={() => {
                      openModal()
                      setProductTitle(tabData[activeIdx].title)
                    }}>
                      <button
                        className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                      >
                        <span className="flex justify-center items-center">
                          <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                          <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                        </span>
                        Contact Us
                      </button>
                      {/* <Button title="Contact Us" /> */}
                    </div>

                    <div className='group cursor-pointer'>
                      <a href={tabData[activeIdx].fileLink} target="_blank" className='text-gray-600'>
                        <button
                          className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                        >
                          <span className="flex justify-center items-center">
                            <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                            <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                          </span>
                          Brochure
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
                {/* <div className="flex flex-wrap gap-x-10 gap-y-6 items-center justify-start mt-3">
                  <div className="flex flex-nowrap gap-2 md:gap-3 items-center ">
                    <img
                      loading="lazy"
                      src={capacity}
                      alt="charging"
                      className=" h-6  md:h-8 w-auto object-contain objet-center"
                    />
                    <span className="text-sm sm:text-base lg:text-lg  font-poppins font-semibold  ">
                      {tabData[activeIdx].availFrom +
                        ' kW' +
                        (tabData[activeIdx].availTo
                          ? ' to ' + tabData[activeIdx].availTo + ' kW'
                          : '')}
                    </span>
                  </div>

                  {tabData[activeIdx].socketType.map((elem) => {
                    return <Chip data={socketType[elem]} />;
                  })}
                </div> */}

                {/* <div className="self-start">
                  <Button
                    onClick={() => {
                      window.open(tabData[activeIdx].fileLink);
                    }}
                    title="Learn More"
                    className="mt-4"
                  />
                </div> */}
              </div>
            </Transition>
          </SwitchTransition>
        </div>
        <div className=" top-auto left-0 bottom-0 right-0 lg:hidden block overflow-hidden ">
          <Slider {...sliderSettings} className="lg:hidden block z-10">
            {tabs.map((elem, index) => {
              return (
                <button
                  key={index}
                  onClick={() => setActiveIdx(index)}
                  className={` ${activeIdx === index
                    ? 'text-green border-green border rounded-xl'
                    : ''
                    } text-black hover:text-green font-poppins whitespace-nowrap text-base xl:text-lg py-2  px-3 grid place-content-center`}
                >
                  {elem}
                </button>
              );
            })}
          </Slider>
        </div>
        <div className="basis-80 grow shrink flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px]">
          <div className="absolute top-0 left-auto bottom-0 right-0 bg-gradient w-32 md:w-56 lg:w-80"></div>


          <div className="mt-0 md:mt-10 mx-3 w-10/12 md:max-w-[850px] max-w-sm grid place-content-center md:px-10 lg:px-20  bg-grey z-10 h-5/6 lg:h-4/5 rounded-3xl overflow-hidden relative">
            {/* 
            <Slider {...sliderSettings2} className="w-10/12 md:max-w-[850px] max-w-sm mx-auto">
              {tabData[activeIdx].imgSrc.map((src, index) => {
                return (
                  <div>
                    <h3 className='opacity-0'>1</h3>
                    <img
                      key={index}
                      src={src}
                      alt={index}       
                      className="h-[500px] mx-auto"     
                    />
                  </div>
                )
              })}
            </Slider> */}
            <SwitchTransition>
              <Transition
                appear={true}
                timeout={300}
                in={true}
                key={activeIdx}
                onExit={exitAnim}
                onEnter={enter}
                mountOnEnter
                unmountOnExit
              >
                <div>
                  <div className="absolute top-0 left-0 bottom-auto right-auto bg-verde/10 w-20 rounded hidden lg:block p-4 rounded-br-3xl">
                    <div className='flex items-center flex-col space-y-4'>
                      {tabData[activeIdx].compatibility.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={CompatibilityType[elem]} type="true" />
                          </div>
                        );
                      })}

                    </div>
                  </div>
                  {/* <div className="absolute bottom-0 right-0 left-auto top-auto rounded hidden lg:block p-4 rounded-br-3xl">
                    <div className='flex items-center flex-col space-y-4 grayscale '>
                      <p className='flex items-center text-lg text-lighyGray'><img src={madeInInda} className="w-6 mr-2 grayscale" /> Made In India</p>

                    </div>
                  </div> */}
                  <div className="absolute bottom-auto right-0 left-auto top-0 hidden p-4">
                    <div className="flex items-center py-2 sm:py-3 gap-3">
                      <div onClick={() => {
                        openModal()
                        setProductTitle(tabData[activeIdx].title)
                      }}>
                        <button
                          className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-12 pr-6 !h-[35px] text-sm font-poppins'
                        >
                          <span className="flex justify-center items-center">
                            <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                            <BsArrowRightShort className="h-[25px] w-[25px] tailArrow" />
                          </span>
                          Contact Us
                        </button>
                        {/* <Button title="Contact Us" /> */}
                      </div>

                      <div className='group cursor-pointer'>
                        <a href={tabData[activeIdx].fileLink} target="_blank" className='text-gray-600'>
                          <button
                            className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-12 pr-6 !h-[35px] text-sm font-poppins'
                          >
                            <span className="flex justify-center items-center">
                              <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                              <BsArrowRightShort className="h-[25px] w-[25px] tailArrow" />
                            </span>
                            Brochure
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* <div className='absolute left-0 bottom-0 w-28 bg-verde/10 p-4 rounded-tr-3xl'>
                    <div className='flex flex-col space-y-6'>
                      {tabData[activeIdx].use.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={userType[elem]} userType="true"/>
                          </div>
                        );
                      })}
                    </div>
                  </div> */}
                  <img
                    loading="lazy"
                    src={tabData[activeIdx].imgSrc}
                    alt={tabData[activeIdx].title}
                    className="mx-auto my-auto object-contain object-center mt-10 z-10 w-full h-[70%] md:h-[80%] lg:h-[85%]"
                  />
                </div>
              </Transition>
            </SwitchTransition>
          </div>
        </div>





        <div className="containers-min mx-auto lg:block hidden  absolute left-0 right-0 -top-10 xLg:top-3 z-20 pb-0 lg:pb-0 xxl:pb-0">
          <div className="rounded-full w-full mb-1 xl:mb-2 bg-gray-200 bg-tab-shadow flex-wrap gap-3 items-center justify-around overflow-visible px-5 py-3 flex">
            {tabs.map((elem, index) => {
              return (
                <button
                  key={index}
                  onClick={() => setActiveIdx(index)}
                  className={` ${activeIdx === index ? 'bg-white text-black shadow' : 'text-gray-600'
                    } text-black hover:text-green font-poppins text-base xl:text-lg rounded-full px-4 py-3 transition-colors duration-300`}
                >
                  {elem}
                </button>
              );
            })}
          </div>
        </div>

      </section>
      {isModalOpen && <FormModal isModalOpen={isModalOpen} productTitle={productTitle} setIsModalOpen={setIsModalOpen} />}
    </>
  );
}
